var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval61AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 111 50",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M18 6c0-2.046-2.06-4-5-4S8 3.954 8 6v1a1 1 0 1 1-2 0V6c0-3.477 3.312-6 7-6s7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M30 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M35 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M47 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M52 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M64 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M69 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M81 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M86 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M98 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M103 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M0 32c0-9.941 8.059-18 18-18h75c9.941 0 18 8.059 18 18s-8.059 18-18 18H18C8.059 50 0 41.941 0 32Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M93 16H18C9.163 16 2 23.163 2 32s7.163 16 16 16h75c8.837 0 16-7.163 16-16s-7.163-16-16-16Zm-75-2C8.059 14 0 22.059 0 32s8.059 18 18 18h75c9.941 0 18-8.059 18-18s-8.059-18-18-18H18Z",
  clipRule: "evenodd"
})));
SvgOval61AError.viewBox = '0 0 111 50';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval61AError);
export default ForwardRef;